<template>
    <v-main>
        <keep-alive>
            <router-view v-if="$route.meta.keepAlive"></router-view>
        </keep-alive>
        <router-view v-if="!$route.meta.keepAlive"></router-view>
    </v-main>
</template>

<script>
export default {
    name: "Station",
    mounted() {},
    methods: {},
};
</script>
